import React from 'react'
import { observer } from 'mobx-react'
import { localisationMaster } from 'Localisation/Localisation'
import st from './DiscountMarkup.module.css'
import asideModalStore from 'Stores/asideModalStore'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormField from 'components/UI/AsideModal/Form/FormField'
import SearchInput from 'components/ContentBox/Global/SearchInput/SearchInput'

const StudentPrice = ({ translate }) => {
  const { modalValues, changeValue, check } = asideModalStore

  return (
    <div className={st.form}>
      <FormField>
        <FormLabel isRequired>{translate?.price_type}:</FormLabel>
        <SearchInput
          link='groups/price_sums'
          placeholder={localisationMaster('text_7', 'groups/group')}
          formatOption={(opt) =>
            `${opt.name} (${opt.price_sum}.00тг. за ${opt.hours_sum} ${
              opt.hours_type.id === 1
                ? localisationMaster('ac_h', 'groups/group')
                : localisationMaster('astr_h', 'groups/group')
            })`
          }
          backFunction={(o) => changeValue(o.id, 'default_price_id')}
          initialValue={modalValues.default_price_name || null}
          backFunctionByObj={false}
          error={check('default_price_id')}
        />
      </FormField>
      <FormDateSelector
        placeholder={translate?.start_date}
        isRequired
        button={{ name: translate?.today, action: 'today' }}
        label={translate?.start_date}
        onChange={(val) =>
          changeValue(dateFormat(val, 'YYYY-mm-dd'), 'date_from')
        }
        value={modalValues.date_from || ''}
        error={check('date_from')}
      />
      <FormDateSelector
        placeholder={translate?.end_date}
        isRequired={false}
        button={{ name: translate?.reset, action: 'reset' }}
        label={translate?.end_date}
        onChange={(val) =>
          changeValue(val ? dateFormat(val, 'YYYY-mm-dd') : null, 'date_until')
        }
        minDate={new Date(modalValues.date_from)}
        value={modalValues.date_until || ''}
        error={check('date_until')}
      />
      <div>
        <ToggleCheckbox
          label={translate?.send_notification}
          checked={modalValues.send_email}
          onChange={() => changeValue(!modalValues.send_email, 'send_email')}
        />
      </div>
    </div>
  )
}

export default observer(StudentPrice)
